<!-- @format -->

<template>
	<router-view v-slot="{ Component }">
		<template v-if="Component">
			<transition mode="out-in">
				<component :is="Component" />
			</transition>
		</template>
	</router-view>
</template>

<script lang="ts" setup></script>
